var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
// - Import app components
import { MobileDisplayPost, DesktopDisplayPost } from 'src/components/post';
import Swiper from 'react-id-swiper';
import { fetchPostsByUserId, fetchPostsByTypeLimit } from './reducer';
import './NewStream.css';
var Slideparams = {
    slidesPerView: 2,
    spaceBetween: 5,
    freeMode: true,
    scrollbar: {
        el: '.swiper-scrollbar',
        dragClass: 'thumbBar',
        hide: false,
    },
};
var DSlideparams = {
    slidesPerView: 4,
    spaceBetween: 5,
    freeMode: true,
    swipe: true,
    scrollbar: {
        el: '.swiper-scrollbar',
        dragClass: 'thumbBar',
        hide: false,
    },
};
var NewStream = function (props) {
    var _a = useState(1), count = _a[0], setCount = _a[1];
    var _b = useState([0]), divArr = _b[0], setDivArr = _b[1];
    var _c = useState([]), postArr = _c[0], setPostArr = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(true), hasMore = _e[0], setHasMore = _e[1];
    var _f = useState({}), lastPost = _f[0], setLastPost = _f[1];
    var _g = useState('Sweaters'), Type = _g[0], SetType = _g[1];
    var arr = [];
    // useEffect(() => {
    //     setLastPost({})
    //     AddPostsToState()
    // }, [postArr, Type])
    useEffect(function () {
        // alert('changed')
        setPostArr([]);
        setLastPost({});
        AddPostsToState();
    }, [props.Type]);
    useEffect(function () {
    }, [isLoading]);
    var getPosts = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(props.SearchType === 'ByUser')) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchPostsByUserId(props.userId, lastPost, 3).then(function (cont) {
                            cont.posts.forEach(function (post) {
                                console.dir(Object.values(post)[0]);
                                var mymap = Map(Object.values(post)[0]);
                                arr.push(mymap);
                                if (arr.length > 5) {
                                    return;
                                }
                                var id = mymap.get('id');
                            });
                            setLastPost(cont.last);
                            console.log('LP', cont.last.id);
                            console.log('state LP', lastPost.id);
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fetchPostsByTypeLimit(props.Type, lastPost).then(function (cont) {
                        cont.posts.forEach(function (post) {
                            console.dir(Object.values(post)[0]);
                            var mymap = Map(Object.values(post)[0]);
                            arr.push(mymap);
                            if (arr.length > 5) {
                                return;
                            }
                            var id = mymap.get('id');
                        });
                        setLastPost(cont.last);
                        // console.log('LP', cont.last.id)
                        // console.log('state LP', lastPost.id)
                    })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, arr];
            }
        });
    }); };
    var getPostsById = function () { return __awaiter(_this, void 0, void 0, function () {
        var context;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchPostsByUserId('YFHhfCPlCzXz9OWozLyXaPqlOeP2', lastPost)];
                case 1:
                    context = _a.sent();
                    context.posts.forEach(function (post) {
                        console.dir(Object.values(post)[0]);
                        var mymap = Map(Object.values(post)[0]);
                        arr.push(mymap);
                        var id = mymap.get('id');
                    });
                    setLastPost(context.last);
                    return [2 /*return*/, arr];
            }
        });
    }); };
    var AddPostsToState = function () {
        if (hasMore) {
            getPosts().then(function (posts) {
                var allposts = postArr.concat(posts);
                setPostArr(allposts);
                setIsLoading(false);
            }).catch(function (err) { console.log('somerr', err); });
        }
    };
    return (React.createElement("div", { className: '', style: { backgroundColor: 'white' } }, window.outerWidth < 500 ?
        React.createElement("div", { style: { maxWidth: '100%', minWidth: '160px', verticalAlign: 'top', display: 'flex', overflowX: 'auto' } },
            React.createElement(Swiper, __assign({ shouldSwiperUpdate: isLoading }, Slideparams), postArr.map(function (post) { return (React.createElement("div", { className: '' },
                React.createElement(MobileDisplayPost, { objectFit: props.objectFit, FontColor: 'black', key: post.get('id') + "-stream-div-post", post: post }))); })))
        :
            React.createElement("div", { style: { maxWidth: '100%', minWidth: '160px', verticalAlign: 'top', display: 'flex', overflowX: 'auto' } },
                React.createElement(Swiper, __assign({ shouldSwiperUpdate: true }, DSlideparams), postArr.map(function (post) { return (React.createElement("div", { style: { paddingBottom: '5vh' }, className: '' },
                    React.createElement(DesktopDisplayPost, { objectFit: props.objectFit, FontColor: 'black', key: post.get('id') + "-stream-div-post", post: post }))); })))));
};
var mapStateToProps = function (state) {
    var uid = state.getIn(['authorize', 'uid']);
    var user = state.getIn(['user', 'info', uid]);
    var Scene = state.getIn(['renderer', 'StateScene']);
    var Camera = state.getIn(['renderer', 'StateCamera']);
    var MorePosts = state.getIn(['post', 'stream', 'hasMoreData'], true);
};
var mapDispatchToProps = function (state) { return ({}); };
export default connect(mapStateToProps, mapDispatchToProps)(NewStream);



//////////////////
// WEBPACK FOOTER
// ./src/containers/Stream2/SideWays2.tsx
// module id = 1327
// module chunks = 0 1 2 3 4 5 6 7